import * as utils from "common/utils";
import * as ghgUtils from "./_utils";
import { Bar, Pie } from "react-chartjs-2";

export default function GhgEmissionsGraph({ ghgResults }) {
    if (!ghgResults) return null;

    const emissionsData = [].concat(
        ghgResults.emissions.methane.sources.map((emissions) => getEmissionsData(emissions, ghgUtils.gas.methane)),
        ghgResults.emissions.nitrousOxide.sources.map((emissions) => getEmissionsData(emissions, ghgUtils.gas.nitrousOxide)),
        ghgResults.emissions.carbonDioxide.sources.map((emissions) => getEmissionsData(emissions, ghgUtils.gas.carbonDioxide))
    );

    const pieData = [ghgResults.emissions.methane.sources.reduce((t, c) => (t += c.emissionsPerHectare.value), 0), ghgResults.emissions.nitrousOxide.sources.reduce((t, c) => (t += c.emissionsPerHectare.value), 0), ghgResults.emissions.carbonDioxide.sources.reduce((t, c) => (t += c.emissionsPerHectare.value), 0)];
    const totalPie = pieData.reduce((t, d) => (t += d || 0), 0);
    if (totalPie > 0) {
        pieData[0] = ((pieData[0] || 0) / totalPie) * 100;
        pieData[1] = ((pieData[1] || 0) / totalPie) * 100;
        pieData[2] = ((pieData[2] || 0) / totalPie) * 100;
    }

    const pieChartData = {
        labels: ["Methane", "Nitrous oxide", "Carbon dioxide"],
        datasets: [
            {
                fill: "origin",
                lineTension: 0,
                backgroundColor: [ghgUtils.gas.methane.colour.hex, ghgUtils.gas.nitrousOxide.colour.hex, ghgUtils.gas.carbonDioxide.colour.hex],
                labels: ["%", "%", "%"],
                data: pieData.map((d) => utils.numeric.format(d, 1)),
            },
        ],
    };

    const barChartData = {
        labels: emissionsData.map((d) => d.label),
        datasets: [
            {
                fill: "origin",
                lineTension: 0,
                backgroundColor: emissionsData.map((d) => d.colour),
                borderColor: "black",
                pointRadius: 0,
                data: emissionsData.map((d) => utils.round(d.value, 0)),
            },
        ],
    };

    const options = {
        scales: {
            x: { display: true, ticks: { autoSkip: false } },
            y: {
                ticks: { beginAtZero: true },
                display: true,
                title: { display: true, text: "kg CO2e/ha" },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
        },
    };

    const pOptions = {
        plugins: {
            legend: {
                display: true,
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem) => {
                        return `${tooltipItem.raw.toLocaleString()} %`;
                    },
                },
            },
        },
        responsive: false,
        maintainAspectRatio: false,
    };

    return (
        <>
            <Bar data={barChartData} height={175} options={options} />
            <div className="u-flex u-flexJustifyCenter">
                <Pie data={pieChartData} options={pOptions} height={400} width={400} />
            </div>
        </>
    )
}

function getEmissionsData(emissions, gas) {
    return {
        label: emissions.name,
        value: emissions.emissionsPerHectare.value,
        colour: gas.colour.hex,
    };
}
